import template from './payment_report_help.html';

class PaymentReportHelpViewModel
{
	constructor (dialog)
	{
		this.dialog = dialog;
	};

	close()
	{
		this.dialog.close();
	}
};

class PaymentReportHelpPage
{
	constructor (bindings)
	{
		this.viewModel = new PaymentReportHelpViewModel(this);
		this.bindings = bindings;
	};
};

// Register the dialog
export default {
	name: 'PaymentReportHelp',
	dialog_class: PaymentReportHelpPage,
	template: template,
	template_filename: 'translation/dialogs/payment_report_help',
	provider: 'ps'
};
